export class APIBaseService {
  static apiUrl = process.env.REACT_APP_API_URL as string;
}
